<template>
    <div class="col-12 col-sm-6 col-md-4 p-2">
        <div class="bien d-flex flex-column bg-light border border-dark position-relative">
            <img :src="bien['ann_PHOP__Photo_estPrincipale::d_image']"
                :alt="bien['ann_PHOP__Photo_estPrincipale::d_imageAlt']"
                class="cover">
            <div class="bandeau position-absolute" :class="classStatus(bien.d_statut)"></div>
            <p class="openSans-bold px-3 py-1 m-0">Réf. {{ bien.d_reference }}</p>
            <p class="openSans-bold small-ls text-secondary text-uppercase px-3 py-1 m-0">{{ bien.d_titre }}</p>
            <p class="overflow-hidden small-ls px-3 py-1 m-0" v-html="bien.d_descriptif"></p>
            <div class="w-100 d-flex flex-row mt-auto">
                <p class="d-inline-block bg-dark text-primary text-center openSans-bold w-50 m-0 py-2">
                    {{ bien.d_prix }} € FAI</p>
                <router-link
                    :to="{ name: 'Bien', params: { typeSearched: $options.filters.camelCase(bien.d_type), bienRecordId: bien.recordId }}"
                    class="d-inline-block btn btn-primary text-dark w-50 m-0"
                    role="button">
                    <span class="sr-only">Lien vers page présentant le bien immobilier</span>
                    <i class="d-block fa fa-lg fa-eye mx-auto"></i>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'BienPreview',
  props: {
    bien: Object
  },
  methods: {
    classStatus (value) {
      // "En vente" + "Sous offre" + "Sous compromis" + "Vendu"
      if (value !== '' && value !== undefined) {
        return this.$options.filters.camelCase(value)
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
.bien {
    height: 32rem !important;
    overflow: hidden;
    img {
        height: 50% !important;
        position: relative;
        flex-shrink: 0;
    }
    .bandeau {
        transform: rotate(45deg);
    }
    .bandeau.sousOffre {
        top: 2rem;
        right: -2rem;
    }
    .bandeau.sousCompromis {
        top: 3rem;
        right: -2rem;
    }
    .bandeau.vendu {
        top: 0.8rem;
        right: -2rem;
    }
    .bandeau::after {
        padding: 0rem 2rem !important;
    }
    .bandeau.sousOffre::after {
        content: 'Sous offre';
        background-color: yellow;
        color: black !important;
    }
    .bandeau.sousCompromis::after {
        content: 'Sous compromis';
        background-color: orange;
        color: white !important;
    }
    .bandeau.vendu::after {
        content: 'Vendu';
        background-color: red;
        color: white !important;
    }
    .fai {
        height: 2.7rem !important;
    }
}
</style>
